import { FC } from "react";

const RefreshIcon: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props} // allows passing className, style, etc.
  >
    <path
      d="M20.5 35C16.6667 35 13.3264 33.7292 10.4792 31.1875C7.63194 28.6458 6 25.4722 5.58333 21.6667H9C9.38889 24.5556 10.6736 26.9444 12.8542 28.8333C15.0347 30.7222 17.5833 31.6667 20.5 31.6667C23.75 31.6667 26.5069 30.5347 28.7708 28.2708C31.0347 26.0069 32.1667 23.25 32.1667 20C32.1667 16.75 31.0347 13.9931 28.7708 11.7292C26.5069 9.46528 23.75 8.33333 20.5 8.33333C18.5833 8.33333 16.7917 8.77778 15.125 9.66667C13.4583 10.5556 12.0556 11.7778 10.9167 13.3333H15.5V16.6667H5.5V6.66667H8.83333V10.5833C10.25 8.80556 11.9792 7.43056 14.0208 6.45833C16.0625 5.48611 18.2222 5 20.5 5C22.5833 5 24.5347 5.39583 26.3542 6.1875C28.1736 6.97917 29.7569 8.04861 31.1042 9.39583C32.4514 10.7431 33.5208 12.3264 34.3125 14.1458C35.1042 15.9653 35.5 17.9167 35.5 20C35.5 22.0833 35.1042 24.0347 34.3125 25.8542C33.5208 27.6736 32.4514 29.2569 31.1042 30.6042C29.7569 31.9514 28.1736 33.0208 26.3542 33.8125C24.5347 34.6042 22.5833 35 20.5 35ZM25.1667 27L18.8333 20.6667V11.6667H22.1667V19.3333L27.5 24.6667L25.1667 27Z"
      fill="url(#paint0_linear_3206_11925)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3206_11925"
        x1="25.9545"
        y1="35"
        x2="13"
        y2="6.36364"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#231F20" />
        <stop offset="1" stopColor="#F01709" />
      </linearGradient>
    </defs>
  </svg>
);

export default RefreshIcon;
